import React from 'react';

import { 
  Wrap,
  CheckboxWrap, 
  TermsWrap 
} from './styled';

const Terms = [
  '개인정보 수집 및 이용 목적 : 당첨자 선정 및 마케팅 활용',
  '수집하려는 개인정보의 항목 : 이름, 휴대폰 번호, 성별, 연령대, 응답 내용',
  '개인정보의 보유 및 이용기간 : 당첨자 선정 후 3개월간 보관 후 파기됩니다.',
  '본 개인정보 제공에 동의를 거부할 권리가 있으며 동의거부시 이벤트참여가 제한됩니다.',
  '제공하신 개인정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
]

const Checkbox = ({
  name,
  label,
  isChecked,
  checkHander,
}) => {
  return (
    <Wrap>
      <CheckboxWrap>
        <label className="checkbox-label">
          <input type="checkbox" 
            name={name}
            checked={isChecked} 
            onChange={e => checkHander(e)} 
          />
          <span />
          <p>{label}</p>  
        </label>
      </CheckboxWrap>

      <TermsWrap>
        {Terms.map((value, index) => (
          <li key={index}>{value}</li>
        ))}
      </TermsWrap>
    </Wrap>
  );
};

export default Checkbox;
